module.exports = __webpack_public_path__ + "img/weddings_29_H.a1617009.webp";